import { Injectable, OnDestroy } from '@angular/core';

import { publish, refCount } from 'rxjs/operators';

import { Observable, BehaviorSubject } from 'rxjs';
import { AppGlobalsModule as _globals } from 'src/app/app-globals.module';

@Injectable()
export class NotificationService implements OnDestroy {
    private _notification: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    readonly notification$: Observable<string | null> = this._notification.asObservable().pipe(publish(), refCount());

    constructor() {}
    ngOnDestroy(): void {
        if (this._notification) {
            this._notification.unsubscribe();
        }
    }

    notify(message: string | null) {
        // TODO: Urgent to move export from the main thread to worker.

        this._notification.next(message);
        // Prevent timeout call in Universal
        _globals.setTimeoutIsNotServer(() => this._notification.next(null), 5000);
    }
}
